<template>
    <div class="wrapper privacy p-t-70-mobile p-t-90-tablet">
        <div class="columns">
            <div class="column">
                <back-button />
            </div>
        </div>
        <div v-if="article.length > 0" class="columns is-tablet">
            <div class="column is-12-mobile is-9-tablet p-l-150-fullhd p-r-150-fullhd">
                <h1 class="is-size-4 is-size-3-tablet has-text-weight-bold m-b-20 m-b-15-mobile">{{ article[0].title }}</h1>
                <vue-simple-markdown :source="article[0].description.replaceAll('\r', '')" />
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import BackButton from "@/components/BackButton";
export default {
  components: { BackButton },

    data() {
        return {
            article : [],
        }
    },
    methods: {
        getdata() {
            let url = '/api/article/30'
            if(this.$route.params.id){
                url = '/api/article/'+this.$route.params.id
            }
            axios
                .get(url)
                .then(response => {
                    this.article = response.data
                })
                .catch((error) => alert(error))
        }
    },
    mounted() {
        this.getdata();
    },
    metaInfo() {
        return {
            title: "Privacy Policy | Pickafund",
            meta: [
                { name: 'description', content:  'We take privacy and the security of your personal information very seriously. We are committed to protecting and respecting it. Understand our views and practices regarding your personal data.'},
                { property: 'og:title', content: "Privacy Policy | Pickafund"},
            ]
        }
    }
}
</script>
